
export default function AISoftware() {
  return (
    <section id="ai-software" className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Content */}
          <div>
            <h2 className="text-3xl lg:text-[38px] font-semibold text-[#111111]">
              AI &amp; Proprietary Tools
            </h2>
            
            <p className="mt-6 text-[17px] text-[#666666] leading-relaxed">
              We help clients design data pipelines, research dashboards, workflow automation, and AI-assisted analysis tailored to these markets.
            </p>

            <p className="mt-4 text-[17px] text-[#666666] leading-relaxed">
              We design internal research systems, workflow tools and data dashboards tailored to specific client mandates. We do not sell standalone software products.
            </p>

            {/* 3-Step Process */}
            <div className="mt-10 space-y-6">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#B11226] text-white font-semibold rounded-full">
                  1
                </div>
                <div>
                  <h3 className="text-[17px] font-semibold text-[#111111] mb-1">
                    Discover
                  </h3>
                  <p className="text-[15px] text-[#666666]">
                    Identify data needs, workflow bottlenecks, and automation opportunities specific to your market operations.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#B11226] text-white font-semibold rounded-full">
                  2
                </div>
                <div>
                  <h3 className="text-[17px] font-semibold text-[#111111] mb-1">
                    Build
                  </h3>
                  <p className="text-[15px] text-[#666666]">
                    Design and develop custom dashboards, data pipelines, and AI-assisted research tools tailored to your requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#B11226] text-white font-semibold rounded-full">
                  3
                </div>
                <div>
                  <h3 className="text-[17px] font-semibold text-[#111111] mb-1">
                    Deploy
                  </h3>
                  <p className="text-[15px] text-[#666666]">
                    Implement solutions with training and ongoing support to ensure seamless integration into your operations.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Illustration */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/2e4355bb8afb16b3015e9a84e75a64ec/cdebe5f93096370416afe85d9fb315b4.png"
                alt="AI and Proprietary Tools"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}